module.exports = __webpack_public_path__ + "img/busca-avancada-pets-2.06d9ebd7.jpg";